import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {Option, OptionGroupMultiSelect} from '../../../../../shared/models/option';
import {HubsService} from '../../../../../core/services/hubs.service';
import {Hub, HubId} from '../../../../../shared/models/hub';
import {PopoverMultiSelectObjectBaseComponent} from '../_base/popover-multi-select-object-base.component';
import {Observable} from 'rxjs';
import {PopoverMultiSelectComponent} from '../../popover-multi-select.component';

@Component({
  selector: 'motn-popover-select-hubs',
  templateUrl: './popover-select-hubs.component.html',
  styleUrls: ['./popover-select-hubs.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    PopoverMultiSelectComponent,
  ],
})
export class PopoverSelectHubsComponent extends PopoverMultiSelectObjectBaseComponent implements OnInit {
  @Input() preselectedHub: HubId;
  @Input() preselectedHubs: HubId[];
  /**
   * Optional. Supply if there should only be a subset of hubs smaller than all the
   * user's hubs to select from.
   */
  @Input() hubs: Hub[];


  constructor(
    private hubsService: HubsService,
  ) {
    super();
  }


  protected onInit() {
    this.optionGroup$ = new Observable<OptionGroupMultiSelect>(
      subscriber => {
        if (this.optionGroupIsPrepared()) {
          this.initSubscriberHandle(subscriber);
        } else if (!this.hubs) {
          this.hubsService.fetchUserHubs$().subscribe({
            next: (hubs) => {
              this.hubs = hubs;

              this.prepareOptionGroup();
              this.initSubscriberHandle(subscriber);
            },
            error: err => subscriber.error(err),
          });
        } else {
          this.prepareOptionGroup();
          this.initSubscriberHandle(subscriber);
        }
      },
    );
  }


  onSelectHub($event: Option) {
    if ($event) {
      this.clickedOption$.emit($event);
    }
  }


  protected prepareOptionGroup(): OptionGroupMultiSelect {
    const options: Option[] = [];

    for (let hub of this.hubs) {
      // Support both single hub selection and multiple hub selection
      const selected = this.preselectedHub === hub.ID ||
                       !!this.preselectedHubs?.includes(hub.ID);

      options.push({
        id: '' + hub.ID,
        name: hub.Name,
        selected: selected,
        pill: {
          letter: 'h',
          text: hub.ID,
        },
      });
    }

    return this.optionGroup = new OptionGroupMultiSelect(options);
  }
}
